document.addEventListener('DOMContentLoaded', () => {
  const container = document.querySelector('.swiper-banner-container');
  const DURATION = container.dataset.duration ? parseFloat(container.dataset.duration) : 6; // seconds
  const RADIUS = 22;
  const STROKE_WIDTH = 2;
  const CIRCUMFERENCE = 2 * Math.PI * RADIUS;

  const slides = document.querySelectorAll('.banner-item');
  const paginationEl = document.querySelector('.custom-pagination');
  const bullets = [];

  // 创建自定义分页器
  slides.forEach((_, index) => {
    console.log('index', index)
    const bullet = document.createElement('div');
    bullet.className = 'countdown-bullet inactive';
    bullet.innerHTML = `
      <svg width="48" height="48">
        <circle class="circle-bg" cx="24" cy="24" r="${RADIUS}" stroke-width="${STROKE_WIDTH}" fill="none"></circle>
        <circle class="circle-progress" cx="24" cy="24" r="${RADIUS}" stroke-width="${STROKE_WIDTH}" fill="none"
          stroke-dasharray="${CIRCUMFERENCE}"
          stroke-dashoffset="${CIRCUMFERENCE}"></circle>
      </svg>
      <div class="countdown-text">${index + 1}</div>
    `;
    paginationEl.appendChild(bullet);
    bullets.push(bullet);
  });

  const swiperBannerContainer = new Swiper('.swiper-banner-container', {
    loop: true,
    effect: 'fade',
    navigation: {
      nextEl: '.swiper-banner-container .swiper-button-next',
      prevEl: '.swiper-banner-container .swiper-button-prev',
    },
    autoplay: {
      delay: DURATION * 1000,
      disableOnInteraction: false,
    },
    on: {
      slideChangeTransitionStart: () => {
        startCountdown(swiperBannerContainer.realIndex);
      }
    }
  });

  let countdownTimer = null;

  function startCountdown(index) {
    bullets.forEach((b, i) => {
      b.classList.toggle('inactive', i !== index);
      const circle = b.querySelector('.circle-progress');
      circle.style.strokeDashoffset = CIRCUMFERENCE;
    });

    const targetBullet = bullets[index];
    const circle = targetBullet.querySelector('.circle-progress');

    clearInterval(countdownTimer);
    let timeLeft = DURATION;

    countdownTimer = setInterval(() => {
      timeLeft -= 0.1;
      if (timeLeft <= 0) {
        clearInterval(countdownTimer);
        circle.style.strokeDashoffset = 0;
        return;
      }
      const offset = CIRCUMFERENCE * (1 - timeLeft / DURATION);
      circle.style.strokeDashoffset = CIRCUMFERENCE - offset;
    }, 100);
  }

  // 初始化第一张的倒计时
  startCountdown(0);
});